module.exports = __webpack_public_path__ + "analytics-es2015.worker.js"